import { observer } from 'mobx-react'
import React, { Component } from 'react'
import styled from 'styled-components'
import Menu from '../components/Menu'
import Text from '../components/Text'
import patient from '../stores/patient'

const Title = styled.div`
  font-size: 1.1rem;
  font-weight: 500;
  padding: 1rem 0;
`

const TextArea = styled.textarea`
  background: var(--off-white);
  padding: 0.75rem;
  line-height: 125%;
  overflow-y: auto;
  resize: none;
  min-height: 10rem;
  flex: 1;
  width: 90%;
  border: 1px solid transparent;
  &:focus {
    border: 1px solid var(--blue);
  }
  &:last-child {
    margin-bottom: 1.25rem;
  }
`

@observer
export default class NotesMenu extends Component {
  render() {
    return (
      <Menu icon="fas fa-edit" right>
        <Title>
          <Text str="titles.patientNotes" />
        </Title>
        <TextArea
          name="patientNotes"
          value={patient.fields.patientNotes}
          onChange={patient.setField}
        />
        <Title>
          <Text str="titles.counselorNotes" />
        </Title>
        <TextArea
          name="counselorNotes"
          value={patient.fields.counselorNotes}
          onChange={patient.setField}
        />
      </Menu>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/NotesMenu.js